// Module
var code = `<template>
  <require from="./nav-breakdown-widget.scss"></require>

  <div class="nav-breakdown-widget">
    <mdc-circular-progress if.bind="loading"></mdc-circular-progress>
    <!-- chart slightly sticks out from its boundaries, 96% makes sure there's no scroll -->
    <div show.bind="!loading && !error" class="nav-breakdown-widget__chart" style="height: 96%" element.ref="chart">
    </div>
    <message if.bind="error" icon="error" colour="mdc-theme--error" class="nav-breakdown-widget__error">
      \${error.message}</message>
  </div>
</template>
`;
// Exports
export default code;